import React from 'react';
import { useParams } from 'react-router-dom';
import ChatPanel from './ChatPanel';
import './EnvironmentChat.css';

const EnvironmentChat: React.FC = () => {
  const { environmentId } = useParams<{ environmentId: string }>();

  if (!environmentId) {
    return <div>Invalid environment ID</div>;
  }

  return (
    <div className="environment-chat">
      <ChatPanel
        environmentId={environmentId}
        environmentName={`Environment ${environmentId}`}
        onClose={() => {}}
      />
    </div>
  );
};

export default EnvironmentChat;